<template>
  <div class="grid grid-cols-12 items-center gap-3 mb-5">
    <div class="text-right col-span-3">
      {{ $t('Name') }}
    </div>
    <div class="col-span-9">
      <TextboxField :type="'text'" :name="'label'" v-model="customField.label" :isRequired="true" />
    </div>
  </div>
  <div class="grid grid-cols-12 items-center gap-3 mb-4">
    <div class="text-right col-span-3">
      {{ $t('customFields.itemLimit') }}
    </div>
    <div class="flex items-center col-span-9">
      <TextboxField :type="'text'" :name="'minLength'" v-model="customField.minLength" :isNumber="true" :min="0" />
      <span class="mx-4">〜</span>
      <TextboxField :type="'text'" :name="'maxLength'" v-model="customField.maxLength" :isNumber="true" :min="0" />
    </div>
  </div>

  <div class="grid grid-cols-12 items-center gap-3 mb-5">
    <div class="text-right col-span-3"></div>
    <div class="col-span-9">
      <el-checkbox v-model="customField.isScan">
        {{ $t('customFields.isScan') }}
      </el-checkbox>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import { IProjectCustomField } from '@/utils/types'

@Options({
  components: { TextboxField },
  name: 'ListString',
})
export default class ListString extends Vue {
  @Prop({ type: Object }) readonly customField!: IProjectCustomField
}
</script>
